<template>
  <div class="c-appWrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppWrapper',
  props: {},
  mounted() {
    window.addEventListener('resize', this.appHeight);
    this.appHeight();
  },
  destroyed() {
    window.removeEventListener('resize', this.appHeight);
  },
  methods: {
    appHeight() {
      const doc = document.documentElement;
      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    },
  },
};
</script>
